import { getPath } from '@/router/common'

const baseUrl = {
  title: '包裹拼单',
  path: 'CombinePackage'
}
export default [
  {
    path: getPath('index', baseUrl),
    name: 'CombinePackage_index',
    component: () => import(/* webpackChunkName: "CombinePackage_index" */ '@/views/combinePackage/index/index.vue'),
    meta: {
      title: '包裹列表'
    }
  },
   {
    path: getPath('edit', baseUrl),
    name: 'CombinePackage_edit',
    component: () => import(/* webpackChunkName: "CombinePackage_edit" */ '@/views/combinePackage/edit/index.vue'),
    meta: {
      title: '批量修改包裹'
    }
  },
  {
    path: getPath('esiteList', baseUrl),
    name: 'CombinePackage_siteList',
    component: () => import(/* webpackChunkName: "CombinePackage_siteList" */ '@/views/combinePackage/esiteList/index.vue'),
    meta: {
      title: '包裹到站列表'
    }
  }
]
